import React from "react";
import {SingleValue} from "react-select";

import {FilterableColumn, FilterRule} from "../styledTableHelper";
import FilterFields from "./filterFields/FilterFields";
import StaticDropdown from "../../dropdown/staticDropdown/StaticDropdown";
import {Option} from "../../dropdown/DropdownHelper";

import styles from "./FilterWindow.module.scss";

type FilterWindowProps = {
  filterableColumns: FilterableColumn[];
  draftFilterRules: FilterRule[];
  setDraftFilterRules: (rules: FilterRule[]) => void;
};

export default function FilterWindow({
  filterableColumns,
  draftFilterRules,
  setDraftFilterRules,
}: FilterWindowProps) {
  const filterableColumnsOptions = filterableColumns
    .filter(
      (column) =>
        !draftFilterRules.some((rule) => rule.columnId === column.columnId)
    )
    .map((column) => ({
      value: column.columnId,
      label: column.columnHeader,
    }));

  const addNewFilter = (selectedColumn: SingleValue<Option>) => {
    const columnId = selectedColumn?.value;
    const filterableColumn = filterableColumns.find(
      (column) => column.columnId === columnId
    );
    let newFilterRule: FilterRule;
    if (filterableColumn?.columnType === "date") {
      newFilterRule = {
        columnId: filterableColumn?.columnId as string,
        operator: "range",
        startDate: new Date(),
        endDate: new Date(),
      };
    } else {
      newFilterRule = {
        columnId: filterableColumn?.columnId as string,
        operator: filterableColumn?.columnType === "select" ? "equals" : "in",
        value: "",
      };
    }
    setDraftFilterRules([...draftFilterRules, newFilterRule]);
  };

  return (
    <div className={styles.filterWindow}>
      <StaticDropdown
        classname={styles.addFilterButton}
        title={{value: "Add New Filter +", label: "Add New Filter +"}}
        options={filterableColumnsOptions}
        onChange={addNewFilter}
      />
      <FilterFields
        filterableColumns={filterableColumns}
        draftFilterRules={draftFilterRules}
        setDraftFilterRules={setDraftFilterRules}
      />
    </div>
  );
}
